import { createSelector } from 'reselect';

export const getUserState = state => state.get('user');
export const isAuthorized = state => state.getIn(['user', 'isAuthorized']);
export const isAuthenticated = state => state.getIn(['user', 'isAuthenticated']);

export const isAnonymous = createSelector(
  isAuthorized,
  isAuthenticated,
  (authorized, authenticated) => authorized && !authenticated
);
